import React, { useState } from 'react'
import styles from "./Planandpricing.module.css"
import pricing from "../../json/Planandpricing.json"

const Planandpricing = () => {
    const [currentPlan, setCurrentPlan] = useState("Basic");
    const [annual, setAnnual] = useState(false);
    return (
        <div className={styles.planouter}>
            <div className={styles.pricingheader}>
                <h1>Upgrade your plan for more features</h1>
            </div>
            <div className={styles.currentplan}>
                <p>Current Plan:</p><span>{currentPlan}</span>
            </div>

            <div className={styles.cardouter}>
                <div className={styles.plantoggle}>
                    <button onClick={() => setAnnual(false)} className={annual ? styles.inactive : styles.active}>Monthly</button>
                    <button onClick={() => setAnnual(true)} className={annual ? styles.active : styles.inactive}>Annual</button>
                </div>

                <div className={styles.cardinner}>
                    {
                        pricing.map((data, ind) => (
                            <div className={styles.card}>
                                <div className={styles.cardsec1}>
                                    <img src={process.env.PUBLIC_URL + data.img} alt='plan_img' />
                                    <div className={styles.priceheading}>
                                        <div className={styles.cardtitle}>
                                            <h1>{data.title}</h1>
                                            {data.title === "Pro" ? <p className={styles.popular}>Most Popular</p> : ""}
                                        </div>
                                        <p>{data.desc}</p>
                                    </div>
                                </div>
                                <div className={styles.cardsec2}>
                                    <h1>{!annual ? data.monthlyinr : data.yearlyinr}</h1>
                                    <p>{!annual ? data.monthlydesc : data.yearlydesc}</p>
                                </div>
                                <div className={styles.cardsec3}>
                                    {
                                        data.features.map((feat, i) => (
                                            <p className={styles.featurelist}>{feat}</p>
                                        ))
                                    }

                                </div>
                                <button className={styles.planbutton} style={currentPlan === data.title ? { backgroundColor: 'var(--primary)', color: "var(--btn-text)", border: "var(--border-none)" } : undefined} onClick={() => setCurrentPlan(data.title)}>
                                    {currentPlan === data.title ? "Current Plan" : data.button}
                                </button>
                            </div>
                        ))
                    }

                </div>
            </div>
        </div >
    )
}

export default Planandpricing